"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle forms
 *
 * @namespace
 * @memberOf txGs1Base.forms
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.forms.select = {
    /**
     * Initialize selectbox replacement,
     * Tweak chosen layout
     */
    initialize: function () {
        // 'use strict';
        //
        // if (scope === 'desktop') {
        // 	$('[data-selectbox="true"]').not(':hidden').chosen({
        // 		'disable_search': true
        // 	});
        // 	$('.chosen-single').each(function (index, chosenSingleItem) {
        // 		$(chosenSingleItem).find('div').remove();
        // 		var text = $(chosenSingleItem).text();
        // 		$(chosenSingleItem).addClass('btn icon-btn minor arrow-down').html(
        // 			'<em class="icon" aria-hidden="true"></em><span class="buttontext">' + text + ' </span>'
        // 		);
        // 	});
        // }
    }
};
exports.default = {};
